import { ComparisonItem } from './useProductComparisonStore';

const MESSAGE_PREFIX = 'Jeg vil gerne sammenligne';

/**
 * Diverge's chat flow is triggered by this message. The id pins the exact product.
 *
 * "Jeg vil gerne sammenligne A (111), B (222) og C (333)"
 */
export const buildComparisonMessage = (items: ComparisonItem[]) => {
    const labels = items.map(({ name, id }) => `${name} (${id})`);

    if (!labels.length) return '';

    const last = labels[labels.length - 1];
    const rest = labels.slice(0, -1);
    const list = rest.length ? `${rest.join(', ')} og ${last}` : last;

    return `${MESSAGE_PREFIX} ${list}`;
};
